import { MdOutlineMessage } from "react-icons/md"
import { Button, ButtonLoader } from "../../components/Button"
import { ListViewUser } from "../../components/ListView"
import {
  ModalBody,
  ModalDouble,
  ModalFooter,
  ModalHeader,
  ModalPanel,
} from "../../components/Modal"
import ModalAlert from "../../components/ModalAlert"
import { Grid } from "../../components/Table"
import { AvatarIcon } from "../../components/Avatar"
import { useCopyClipBoard } from "../../core/utils/hooks/copyToClipBoard"
import "./styles.scss"
import { LoadingWithLabel } from "../../components/Loading"

export const OnRowClickCell = ({ value, copyToClipBoard }) => {
  return (
    <div
      className="rgt-cell-inner"
      style={{ display: "flex", alignItems: "center", overflow: "hidden" }}
      onClick={(e) => copyToClipBoard(value, "Link copiado com sucesso")}
    >
      {value}
    </div>
  )
}

const ModalSendLink = ({
  selectedUsers,
  generateLink,
  saving,
  onCheckedChange,
  checked,
  showTemplates,
  generatedLink,
  sendLink,
  columns,
  generating,
  success
}) => {
  return (
    <>
      <ModalDouble title="Produtores Selecionados" position={"left"} noPadding>
        <ListViewUser
          {...{
            onCheckedChange,
            checked,
          }}
          className="no-border withErrorColumn"
          data={
            Array.isArray(selectedUsers)
            ? selectedUsers.map((item) => ({
                id: item?.farmerId || item?.id,
                image: item?.image,
                name: item?.farmerName || item?.name,
                email: item?.email,
                isChecked: item?.isChecked,
              }))
            : []
          }
        />
      </ModalDouble>
      <ModalDouble
        position={"right"}
        className={`${!showTemplates ? "secondary message-button-template" : "secondary"}`}>
          <>
          {generating ? <LoadingWithLabel labelLoading={`${generatedLink.length}/${checked.length} link(s) gerado(s) aguarde....`} colorSpinner="primary"/> : !generating && success ? (
          <Grid isPaginated={false} columns={columns()} rows={generatedLink} height={450} />
        ) : (
          <div className="empty-links">Sem Links Enviados</div>
        ) }
        {/* {generatedLink.length > 0 ? (
          <Grid isPaginated={false} columns={columns()} rows={generatedLink} height={450} />
        ) : (
          <div className="empty-links">Sem Links Enviados</div>
        )} */}
          </>
        
        <ModalFooter className="p-0">
          <ButtonLoader
            label="Gerar Link"
            handleClick={() =>
              ModalAlert.warn({
                title: "Deseja continuar ?",
                confirmLabel: "Gerar",
                onConfirm: () => generateLink(),
              })
            }
            isDisabled={!checked.length || saving || success}
            color="orange"
            loading={generating}
            messageProcess=""
          />
          <ButtonLoader
            label="Enviar Link"
            handleClick={() =>
              ModalAlert.warn({
                title: "Os links serão enviados no formato abaixo, deseja confirmar?",
                text: '"Para darmos início, faremos a instalação do aplicativo por onde você irá conversar com o seu técnico. Instale o aplicativo pelo link {{LINK MÁGICO}}"',
                confirmLabel: "Enviar",
                onConfirm: () => sendLink(),
              })
            }
            isDisabled={!checked.length || !generatedLink.length || generating}
            color="orange"
            loading={saving}
            messageProcess="Enviando Mensagem"
          />
        </ModalFooter>
      </ModalDouble>
    </>
  )
}

const SendMagicLinkScreen = ({
  modalMagicLinkIsOpen,
  selectedUsers,
  handleCloseModal,
  generateLink,
  text,
  saving,
  onCheckedChange,
  checked,
  generatedLink,
  sendLink,
  generating,
  success,
  exportUsers
}) => {
  const copyToClipBoard = useCopyClipBoard()

  const columns = () => [
    {
      id: "name",
      field: "name",
      label: "Usuário",
      width: "200px",
      cellRenderer: ({ data }) => (
        <div className="rgt-cell-inner action">
          <div className="mnj-table-user-component">
            <div className="mnj-table__item-icon">
              <AvatarIcon icon={data?.image} name={data?.name} size={30} />
            </div>
            <div className="mnj-table-user-component-info">
              <span className="mnj-table-user-component-info-name">{data?.name}</span>
              <span className="mnj-table-user-component-info-email">{data?.email}</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: "link",
      field: "dynamicLink",
      label: "Links Gerados",
      width: "400px",
      cellRenderer: ({ value }) => (
        <OnRowClickCell {...{ value }} copyToClipBoard={copyToClipBoard} />
      ),
    },
  ]

  return (
    <>
      {modalMagicLinkIsOpen && (
        <ModalPanel modalIsOpen={modalMagicLinkIsOpen}>
          <ModalHeader closeModal={handleCloseModal} title="Enviar Link Mágico">
            <div>
            <ButtonLoader
              label="Exportar Dados"
              handleClick={() => exportUsers()}
              isDisabled={!generatedLink.length || generating}
              color="orange"
              loading={saving}
              messageProcess="Exportando dados"
            />
            </div>
          </ModalHeader>
          <ModalBody className="modal-message">
            <ModalSendLink
              {...{
                selectedUsers,
                generateLink,
                text,
                saving,
                onCheckedChange,
                checked,
                generatedLink,
                sendLink,
                copyToClipBoard,
                columns,
                generating,
                success
              }}
            />
          </ModalBody>
        </ModalPanel>
      )}
    </>
  )
}

export default SendMagicLinkScreen
